export default "__VITE_ASSET__67634530__"